module.exports = __webpack_public_path__ + "static/media/success-capture-4.2c140733.png";